import React from 'react';
import { motion } from 'framer-motion';

const AnimatedSection = ({ children, animation }) => {
    const defaultAnimation = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0 },
    };

    return (
        <motion.div
            initial="hidden"
            animate="visible"
            variants={animation || defaultAnimation}
            transition={{ duration: 0.5 }}
        >
            {children}
        </motion.div>
    );
};

export default AnimatedSection;